import { tier } from "../game/tiers";
import { t } from "../i18n";

export type LabelMode = "number" | "roman" | "name" | "none";

const ROMAN: Array<[number, string]> = [
  [10, "X"],
  [9, "IX"],
  [5, "V"],
  [4, "IV"],
  [1, "I"],
];

export function toRoman(n: number): string {
  let out = "";
  let v = n;
  for (const [val, sym] of ROMAN) {
    while (v >= val) {
      out += sym;
      v -= val;
    }
  }
  return out;
}

/** Board/HUD label for a tier level under the chosen notation. */
export function tierLabel(level: number, mode: LabelMode): string {
  switch (mode) {
    case "none":
      return "";
    case "roman":
      return toRoman(level);
    case "name":
      return t(`tier.${tier(level).key}`);
    case "number":
    default:
      return String(level);
  }
}
